import { Navigate, Route, Routes } from "react-router";
import { App as AntApp, ConfigProvider } from "antd";
import useGlassTheme from "./glassTheme";
import { useThemeManager } from "./utils/useThemeManager";
import AdminShell from "./components/layout/adminShell";
import LoginScreen from "./screens/auth/loginScreen";
import AcceptInviteScreen from "./screens/auth/acceptInvite";
import CompanyOverviewScreen from "./screens/common/companyOverview";
import WorkspaceScreen from "./screens/common/workspace";
import GovernanceScreen from "./screens/common/governance";
import SectorHomeScreen from "./screens/common/sectorHome";
import WheelsDashboardScreen from "./screens/wheels/dashboard";
import WheelsOperationsScreen from "./screens/wheels/operations";
import WheelsDealersScreen from "./screens/wheels/dealers";
import WheelsCatalogScreen from "./screens/wheels/catalog";
import WheelsCustomersScreen from "./screens/wheels/customers";

export default function App() {
  const currentTheme = useThemeManager();
  const configTheme = useGlassTheme(currentTheme);

  return (
    <ConfigProvider theme={configTheme}>
      <AntApp>
        <div className="app-viewport bg-light-bg text-black transition-colors dark:bg-dark-bg dark:text-white">
          <Routes>
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/accept-invite" element={<AcceptInviteScreen />} />
            <Route path="/" element={<AdminShell />}>
              <Route index element={<Navigate to="/overview" replace />} />
              <Route path="overview" element={<CompanyOverviewScreen />} />
              <Route path="workspace" element={<WorkspaceScreen />} />
              <Route path="governance" element={<GovernanceScreen />} />

              <Route path="wheels/dashboard" element={<WheelsDashboardScreen />} />
              <Route path="wheels/operations" element={<WheelsOperationsScreen />} />
              <Route path="wheels/dealers" element={<WheelsDealersScreen />} />
              <Route path="wheels/catalog" element={<WheelsCatalogScreen />} />
              <Route path="wheels/customers" element={<WheelsCustomersScreen />} />

              <Route path="health" element={<SectorHomeScreen />} />
              <Route path="homes" element={<SectorHomeScreen />} />
            </Route>
          </Routes>
        </div>
      </AntApp>
    </ConfigProvider>
  );
}
